import { nanoid } from 'nanoid'

/**
 * Axios 请求自动增加 traceId (tid) 插件
 *
 * 使用方式：
 *   traceIdPlugin(axiosInstance)
 *
 * 功能：
 *   为每个请求生成唯一的 tid，并添加到请求头中
 */
export default function traceIdPlugin(axiosInstance) {
  axiosInstance.interceptors.request.use((config) => {
    config.headers.tid = nanoid()
    return config
  })
}
